export default __webpack_public_path__ + "static/media/default_routes.8af5bb1f.svg";